import { gql } from '@apollo/client';

export const GET_USERS_LIST = gql`
  mutation getUsersList($body: Body!) {
    usersList(body: $body)
      @rest(
        type: "Get Users List"
        path: "list"
        method: "POST"
        bodyKey: "body"
      ) {
      id
      fullName
      email
      profilePicture
      company
    }
  }
`;
